// extracted by mini-css-extract-plugin
module.exports = {"close":"VideoAd_close__C_1Wh","container":"VideoAd_container__U8MBw","showingAdhesion":"VideoAd_showingAdhesion__h4Bd7","player":"VideoAd_player__Q67Mo"};